import { render, staticRenderFns } from "./ThisYear.vue?vue&type=template&id=dc66c678&"
import script from "./ThisYear.vue?vue&type=script&lang=ts&"
export * from "./ThisYear.vue?vue&type=script&lang=ts&"
import style0 from "./ThisYear.vue?vue&type=style&index=0&id=dc66c678&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports